import React, { useEffect } from 'react'
import { Input, ListGroup, ListGroupItem, UncontrolledTooltip, UncontrolledPopover, PopoverHeader, PopoverBody } from 'reactstrap';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import moment from 'moment';
import { Bot_Thread_Delete } from '../../slices/thunks';
import { useDispatch } from 'react-redux';
import { close_confirm_modal, open_confirm_modal } from '../../slices/Confirm_Modal/reducer';
import { waitForDecision } from '../../utility/wait_for_confirmation';
import Loader from '../../Components/Common/Loader';
import { change_selected_thread } from '../../slices/Thread/reducer';
import { convertISODateToUserLocal } from '../../slices/layouts/utils';
import Edit_Thread_Name_Modal from '../../Components/Common/CustomModal/Edit_Thread_Name_Modal';
const BotThreadList = ({ thread,selectAll , setselectAll , onClickAdd_select_thread_for_deletion,  onClick_remove_from_selected_thread_list }) => {
    const dispatch = useDispatch()

    const { threadList , selectedthread , temp_selected_thread_title } = useSelector((state)=>state.Threads)
    const {User_Role , Bot_ID } = useSelector((state)=>state.BotDetails.Bot_Details)

    const deleteSingleThread = async ()=>{
        dispatch(open_confirm_modal(" Are you sure you want to delete this thread")) 

   waitForDecision().then((decision)=>{

    
    if(decision){


        dispatch(Bot_Thread_Delete({id:thread.thread_id, Bot_ID: Bot_ID}))

      
          
       }


       dispatch(close_confirm_modal())

   });




       
        
   }


   useEffect(() => {
      setselected(selectAll)
   }, [setselectAll,selectAll])


 



   
   
   
 
    const [selected, setselected] = useState(selectAll)

    useEffect(() => {
        if(selected){
            onClickAdd_select_thread_for_deletion(thread.thread_id)
        }else{
            onClick_remove_from_selected_thread_list(thread.thread_id)
        }
   
    }, [selected,setselected])
    



  return (
   
    <ListGroupItem className={`thread_list_view d-flex justify-content-between align-items-center ${selectedthread.thread_id ===thread.thread_id  ? 'bg-primary-cust' : ''}`}
  >
               {<><div className='chek_name bt_chek_name' data-id={thread.thread_id}>
              {User_Role !== 'Viewer' &&<Input checked={selected} onChange={() => {

                  setselected(!selected);

              } } className="form-check-input me-1" type="checkbox" />}

              <span onClick={()=>{
                  dispatch(change_selected_thread(thread))
              }} className='text-muted'>{  thread.title|| thread.thread_id}</span>          
        
               
               <span className='new_view_date'>{moment(convertISODateToUserLocal(thread.created_at)).format('YYYY-MM-DD hh:mm A')}</span>
          <UncontrolledTooltip placement="bottom"  target={`[data-id="${thread.thread_id}"]`} >{thread.title|| thread.thread_id}</UncontrolledTooltip>
               {/* <UncontrolledPopover placement="bottom" target={`[data-id="${thread.thread_id}"]`} > 
                    <PopoverHeader> thread title</PopoverHeader>
                    <PopoverBody> {thread.title|| thread.thread_id} </PopoverBody>
                </UncontrolledPopover> */}
          </div>
         { User_Role !== 'Viewer' && <span className="dedt">
                  {/* <span>{moment(convertISODateToUserLocal(thread.created_at)).format('YYYY-MM-DD hh:mm A')}</span> */}
                  <span className=''>
                    <Edit_Thread_Name_Modal thread_id={thread.thread_id} thread_title={thread.title}  assistant_id={thread.assets_id} Bot_ID={Bot_ID}  />
                    </span>
                  <span onClick={() => {
                      deleteSingleThread();
                  } }><i className='ri-delete-bin-line'></i></span>
              </span>}
              
              </>
              
              
              }
            </ListGroupItem>
        
                          
 
  )
}

export default BotThreadList